module.exports = __webpack_public_path__ + "img/bom.8d2c8cdc.svg";